import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectors as apiSelectors } from 'zender-api-client';
import intersection from 'lodash/intersection';
import values from 'lodash/values';
import pickBy from 'lodash/pickBy';
import includes from 'lodash/includes';
import sortBy from 'lodash/sortBy';
import * as router from './router';

export const dataSelector = createSelector(
	state => get(state, 'submission.data'),
	data => data
);

export const selectedSelector = createSelector(
	state => get(state, 'submission.selected'),
	selected => selected
);

export const focussedSelector = createSelector(
	state => get(state, 'submission.focussed'),
	focussed => focussed
);

export const itemToRemoveSelector = createSelector(
	state => get(state, 'submission.itemToRemove'),
	itemToRemove => itemToRemove
);

export const messagesSelector = createSelector(
	router.challengeIdSelector,
	apiSelectors.ugc.challengesSelector,
	dataSelector,
	selectedSelector,
	(challengeId, challenges, data, selected) => {
		const challenge = challenges[challengeId] || {};
		const selectedIds = intersection(data, selected);
		const subs = values(pickBy(challenge.submissions, submission => includes(selectedIds, submission.id)));
		return sortBy(subs, item => selected.indexOf(item.id));
	}
);



// WEBPACK FOOTER //
// ./src/selectors/submission.js